import { useAuthStore } from "./authStore";
import { useDevicesStore } from "./devicesStore";
import { useGridStore } from "./gridStore";
import { useLiveTreeStore } from "./liveTreeStore";
import { queryClient } from "../lib/queryClient";

export function clearClientSession() {
  useAuthStore.getState().clear();
  useDevicesStore.getState().clear();
  useGridStore.getState().reset();
  useLiveTreeStore.getState().reset();
  queryClient.clear();
}
